import { Grid, _ } from "gridjs-react";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  GET_TEAM_WISE_REPORT,
  GET_TEAM_WISE_REPORT_LIST,
} from "../../helpers/url_helper";
import moment from "moment";
import { formatDate } from "../../Components/Common/FormDateTime";
import { APIClient } from "../../helpers/api_helper";
import {
  getPreviousDate,
  setCurrentDate,
} from "../../Components/Common/DefaultDateSet";
import { HandleErrorMessage } from "../../Components/Common/HandleErrorMessage";
import Loader from "../../Components/Common/Loader";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useNavigate } from "react-router-dom";
import SubExpired from "../../Components/Common/subExpired";
import { useProfileData } from "../../Components/Hooks/UserHooks";
import { addMonths } from "../../Components/Common/FlatePicker";
import { DatePicker } from "../../Components/Common/Flatpicker";
import CalculateRemainingDays from "../../Components/Common/CalculateRemainingDays";
import TeamSelect from "../../Components/Common/TeamSelect";
import { Table } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import ExpandedRow from "./ExpandedRow";
import Toast from "../../Components/Common/Toast";

const api = new APIClient();

function TeamWiseReport() {
  document.title = "Employee Report";
  const navigate = useNavigate();
  const { profileData } = useProfileData();
  const permissionType = JSON.parse(localStorage.getItem("permission"));
  const viewReportPermission = permissionType?.includes("VIEW_REPORT");
  const loginType = JSON.parse(localStorage.getItem("logintype"));

  const remainingDays = CalculateRemainingDays();
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);

  const [isLoading, setIsLoading] = useState(true);
  const previewsDate = getPreviousDate();
  const currentDate = setCurrentDate();
  const [EmployeeData, setEmployeeData] = useState([]);
  const [selectedFromDate, setSelectedFromDate] = useState(currentDate);
  const [selectedToDate, setSelectedToDate] = useState(currentDate);
  // employee select

  const [employeeRportData, setEmployeeReportData] = useState([]);
  const [shouldFetchData, setShouldFetchData] = useState(true);
  const [dataFetched, setDataFetched] = useState(false);
  const [teamIndu, setTeamIndu] = useState([]);
  const [flag, setFlag] = useState(false);
  // flatPicker Date
  const formattedStartDate = formatDate(selectedFromDate);
  const formattedEndDate = formatDate(selectedToDate);
  const [error, setError] = useState("");
  const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [teamDataCache, setTeamDataCache] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  window.navigateToCallReport = (date, empId, empName) => {
    const formattedEmployees = [
      {
        id: empId,
        value: empName,
        label: empName,
      },
    ];

    if (flag === true || formattedEmployees?.length) {
      navigate("/employee-report", {
        state: {
          dateRng: date,
          teamWiseemployee: formattedEmployees,
        },
      });
    } else {
      Toast("Please click on apply button for redirection", "error");
    }
  };

  useEffect(() => {
    if (teamIndu.length) {
      setFlag(false);
    }
  }, [teamIndu]);

  const columns = [
    {
      title: "Team Name",
      dataIndex: "teamName",
      key: "teamName",
      align: "center",
      width: 35,
      render: (text, record) => {
        const isExpanded = expandedRowKeys.includes(record.key);

        return (
          <div
            onClick={() => handleExpand(!isExpanded, record)}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              cursor: "pointer",
              position: "relative",
            }}
          >
            {/* Fixed-width icon (no shift on click) */}
            <div
              style={{
                width: 18,
                position: "absolute",
                left: 0,
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              {isExpanded ? (
                <DownOutlined style={{ fontSize: 10 }} />
              ) : (
                <RightOutlined style={{ fontSize: 10 }} />
              )}
            </div>

            {/* Center text perfectly */}
            <div
              style={{
                flex: 1,
                textAlign: "center",
              }}
            >
              {text}
            </div>
          </div>
        );
      },
    },

    {
      title: "Total Calls",
      dataIndex: "tCalls",
      key: "tCalls",
      align: "center",
      width: 15,
    },
    {
      title: "Total Duration",
      dataIndex: "tDuration",
      key: "tDuration",
      align: "center",
      width: 20,
    },
    {
      title: "Unique Calls",
      dataIndex: "uniqueClient",
      key: "uniqueClient",
      align: "center",
      width: 16,
    },
    {
      title: "Connected Calls",
      dataIndex: "connectedCalls",
      key: "connectedCalls",
      align: "center",
      width: 20,
    },
    {
      title: <span style={{ color: "green" }}>📞 Incoming</span>,
      children: [
        {
          title: "Total Calls",
          dataIndex: "inTotalCall",
          key: "inTotalCall",
          align: "center",
          width: 12,
        },
        {
          title: "Connected Calls",
          dataIndex: "inConnectedCall",
          key: "inConnectedCall",
          align: "center",
          width: 20,
        },
        {
          title: "Total Duration",
          dataIndex: "indurationCall",
          key: "indurationCall",
          align: "center",
          width: 18,
        },
      ],
    },
    {
      title: <span style={{ color: "#29badb" }}>📤 Outgoing</span>,
      children: [
        {
          title: "Total Calls",
          dataIndex: "outTotalCall",
          key: "outTotalCall",
          align: "center",
          width: 12,
        },
        {
          title: "Connected Calls",
          dataIndex: "outTotalConnected",
          key: "outTotalConnected",
          align: "center",
          width: 20,
        },
        {
          title: "Total Duration",
          dataIndex: "outTotalduration",
          key: "outTotalduration",
          align: "center",
          width: 18,
        },
      ],
    },
    {
      title: "📉 Missed",
      dataIndex: "missed",
      key: "missed",
      align: "center",
    },
    {
      title: "🚫 Rejected",
      dataIndex: "rejected",
      key: "rejected",
      align: "center",
      width: 18,
    },
    {
      title: "Never Attended",
      dataIndex: "naverAttend",
      key: "naverAttend",
      align: "center",
      width: 19,
    },
    {
      title: "Not Picked Up by Client",
      dataIndex: "notPickup",
      key: "notPickup",
      align: "center",
    },
  ];

  const expandedColumns = [
    {
      title: "Team Name",
      dataIndex: "employeeName",
      key: "employeeName",
      align: "center",
      width: 35,
      render: (text, record) => (
        <span
          style={{
            color: "#1890ff",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={() =>
            window.navigateToCallReport(
              record?.date,
              record?.empId,
              record?.employeeName
            )
          }
        >
          {text}
        </span>
      ),
    },

    {
      title: "Total Calls",
      dataIndex: "tCalls",
      key: "tCalls",
      align: "center",
      width: 15,
    },
    {
      title: "Total Duration",
      dataIndex: "tDuration",
      key: "tDuration",
      align: "center",
      width: 20,
    },
    {
      title: "Unique Call",
      dataIndex: "uniqueClient",
      key: "uniqueClient",
      align: "center",
      width: 16,
    },
    {
      title: "Connected Calls",
      dataIndex: "connectedCalls",
      key: "connectedCalls",
      align: "center",
      width: 20,
    },
    {
      title: <span style={{ color: "green" }}>📞 Incoming</span>,
      children: [
        {
          title: "Total Call",
          dataIndex: "inTotalCall",
          key: "inTotalCall",
          align: "center",
          width: 12,
        },
        {
          title: "Connected Call",
          dataIndex: "inConnectedCall",
          key: "inConnectedCall",
          align: "center",
          width: 20,
        },
        {
          title: "Total Duration",
          dataIndex: "indurationCall",
          key: "indurationCall",
          align: "center",
          width: 18,
        },
      ],
    },
    {
      title: <span style={{ color: "#29badb" }}>📤 Outgoing</span>,
      children: [
        {
          title: "Total Call",
          dataIndex: "outTotalCall",
          key: "outTotalCall",
          align: "center",
          width: 12,
        },
        {
          title: "Connected Call",
          dataIndex: "outTotalConnected",
          key: "outTotalConnected",
          align: "center",
          width: 20,
        },
        {
          title: "Total Duration",
          dataIndex: "outTotalduration",
          key: "outTotalduration",
          align: "center",
          width: 18,
        },
      ],
    },
    {
      title: "📉 Missed",
      dataIndex: "missed",
      key: "missed",
      align: "center",
    },
    {
      title: "🚫 Rejected",
      dataIndex: "rejected",
      key: "rejected",
      align: "center",
      width: 18,
    },
    {
      title: "Never Attended",
      dataIndex: "naverAttend",
      key: "naverAttend",
      align: "center",
      width: 19,
    },
    {
      title: "Not Picked Up by Client",
      dataIndex: "notPickup",
      key: "notPickup",
      align: "center",
    },
  ];

  useEffect(() => {
    if (loginType === "employee") {
      // Always fetch for employee
      getEmployeeReportData();
      return;
    }

    if (loginType === "organization" && shouldFetchData && !dataFetched) {
      const employeeIds = teamIndu.map((user) => user.value);

      if (employeeIds.length > 0) {
        getEmployeeReportData(employeeIds);
        setDataFetched(true);
      }
    }
  }, [shouldFetchData, dataFetched, loginType, teamIndu]);

  const handleSubmit = () => {
    setFlag(true);

    if (teamIndu.length === 0 && loginType === "organization") {
      setError("You must select at least one");
      return;
    }

    const employeeIds = teamIndu.map((user) => user.value);
    getEmployeeReportData(employeeIds);
    setShouldFetchData(false); // disable default fetching
    setDataFetched(false); // reset fetch tracker if needed
    setIsSubmitted(true); // mark as manually submitted
    setError("");
    setExpandedRowKeys([]);
    setTeamDataCache({});
  };

  const getEmployeeReportData = async (employeeIds = []) => {
    setIsLoading(true);
    try {
      const data = {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        teamName: employeeIds,
      };

      const response = await api.create(GET_TEAM_WISE_REPORT, data);

      if (response?.success) {
        const transformedData = response.data.map((data, index) => ({
          key: `Team_${data.teamName}_${index}`,
          srNo: index + 1,
          teamName: data.teamName,
          date: data?.dateRange,
          tCalls: data?.totalCall || "-",
          tDuration:
            new Date(data.totalDuration * 1000).toISOString().slice(11, 19) ||
            "-",
          uniqueClient: data?.uniqueClient || "-",
          connectedCalls: data?.connectedCalls || "-",
          inTotalCall: data?.totallIncomingCall || "-",
          inConnectedCall: data?.totallIncomingConnectedCall || "-",
          indurationCall:
            new Date(data?.totallIncomingCallDuration * 1000)
              .toISOString()
              .slice(11, 19) || "-",
          outTotalCall: data?.totallOutgoingCall || "-",
          outTotalConnected: data?.totallOutgoingConnectedCall || "-",
          outTotalduration:
            new Date(data?.totallOutgoingCallDuration * 1000)
              .toISOString()
              .slice(11, 19) || "-",
          missed: data?.totallMissedCall || "-",
          rejected: data?.totalRejectedCall || "-",
          notPickup: data?.totalNotPickedUpByClient || "-",
          naverAttend: data?.neverAttended || "-",
        }));

        setEmployeeReportData(transformedData);
      } else {
        setEmployeeReportData([]);
      }
    } catch (error) {
      HandleErrorMessage(error);
      setEmployeeReportData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (teamIndu.length === 0) {
      setIsLoading(false);
    }
  }, []);

  //reset in field
  const resetInputHistory = () => {
    setSelectedToDate("");
    setSelectedFromDate("");
  };

  const handleClose = () => {
    setIsExpiredModalOpen(false);
    navigate("/planPackage");
  };

  const isWithinRange = (date) => {
    const today = new Date();
    return date >= selectedFromDate && date <= today;
  };

  const handleFromDateChange = (dates) => {
    const newFromDate = dates[0];
    setSelectedFromDate(newFromDate);
    const today = new Date();
    const threeMonthsAfterFromDate = addMonths(newFromDate, 3);

    if (
      selectedToDate >= newFromDate &&
      selectedToDate <= threeMonthsAfterFromDate
    ) {
      return;
    }
    const newToDate =
      threeMonthsAfterFromDate > today ? today : threeMonthsAfterFromDate;
    setSelectedToDate(newToDate);
  };

  const handleToDateChange = (dates) => {
    const newToDate = dates[0];
    if (isWithinRange(newToDate)) {
      setSelectedToDate(newToDate);
    } else {
      console.warn("Selected date is out of range.");
    }
  };

  const handleExpand = async (expanded, record) => {
    const key = record.key;

    if (expanded) {
      setExpandedRowKeys([key]);

      if (!teamDataCache[key]) {
        try {
          const payload = {
            startDate: record?.date?.startDate,
            endDate: record?.date?.endDate,
            teamName: [record?.teamName],
          };

          const response = await api.create(GET_TEAM_WISE_REPORT_LIST, payload);
          if (response?.success) {
            const transformed = response.data[0]?.employees.map(
              (data, index) => {
                return {
                  srNo: index + 1,
                  employeeName: data.employeeName,
                  empId: data.employeeId,
                  date: data?.dateRange,
                  tCalls: data?.totalCall || "-",
                  tDuration:
                    new Date(data.totalDuration * 1000)
                      .toISOString()
                      .slice(11, 19) || "-",
                  uniqueClient: data?.uniqueClient || "-",
                  connectedCalls: data?.connectedCalls || "-",
                  inTotalCall: data?.totallIncomingCall || "-",
                  inConnectedCall: data?.totallIncomingConnectedCall || "-",
                  indurationCall:
                    new Date(data?.totallIncomingCallDuration * 1000)
                      .toISOString()
                      .slice(11, 19) || "-",
                  outTotalCall: data?.totallOutgoingCall || "-",
                  outTotalConnected: data?.totallOutgoingConnectedCall || "-",
                  outTotalduration:
                    new Date(data?.totallOutgoingCallDuration * 1000)
                      .toISOString()
                      .slice(11, 19) || "-",
                  missed: data?.totallMissedCall || "-",
                  rejected: data?.totalRejectedCall || "-",
                  notPickup: data?.totalNotPickedUpByClient || "-",
                  naverAttend: data?.neverAttended || "-",
                };
              }
            );

            setTeamDataCache((prev) => ({
              ...prev,
              [key]: transformed,
            }));
          }
        } catch (error) {
          console.error("Error fetching team data", error);
        }
      }
    } else {
      setExpandedRowKeys([]);
    }
  };

  return (
    <React.Fragment>
      {remainingDays === 0 && isExpiredModalOpen && (
        <SubExpired
          onClose={handleClose}
          profileData={profileData?.selectedPlanDetails?.planName}
          remainingDays={remainingDays}
        />
      )}
      <div className="page-content sn-employee-report-page-main">
        <Container fluid>
          <ReactTooltip
            id="my-tooltip-1"
            place="top"
            className="custom-tooltip"
          ></ReactTooltip>
          <BreadCrumb title="Team Wise Report" pageTitle="Team Wise Report" />
          <Row style={{ marginBottom: "100px" }}>
            <Col lg={12}>
              <Card className="h-100">
                <CardBody className="sn-header-select-employess-home sn-top-inputs-heading sn-employess-tble-main-issue sn-employee-report-tble-respose--">
                  <div className="row">
                    {((viewReportPermission && loginType === "employee") ||
                      loginType === "organization") && (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xs-12">
                        <TeamSelect
                          teamIndu={teamIndu}
                          setTeamIndu={setTeamIndu}
                          selectedEmployeeOptions={selectedEmployeeOptions}
                          setSelectedEmployeeOptions={
                            setSelectedEmployeeOptions
                          }
                          labelContent="Select Team"
                        />
                      </div>
                    )}
                    <div className="col-md-3 col-sm-12">
                      <DatePicker
                        labelContent="From Date"
                        getDate={selectedFromDate}
                        options={{
                          disable: [
                            {
                              from: new Date(),
                            },
                          ],
                          dateFormat: "d M, Y",
                          maxDate: new Date(
                            new Date().setDate(new Date().getDate())
                          ),
                        }}
                        onChange={handleFromDateChange}
                      />
                    </div>

                    <div className="col-md-3 col-sm-12">
                      <DatePicker
                        labelContent="To Date"
                        getDate={selectedToDate}
                        options={{
                          dateFormat: "d M, Y",
                          minDate: selectedFromDate,
                          // maxDate: 'today',
                          enable: [
                            {
                              from: selectedFromDate,
                              to: Math.min(
                                addMonths(selectedFromDate, 3),
                                new Date()
                              ),
                            },
                          ],
                          onOpen: () => {
                            const currentDate = new Date();
                            const threeMonthsFromStart = addMonths(
                              selectedFromDate,
                              3
                            );
                            if (threeMonthsFromStart > currentDate) {
                              return {
                                enable: [
                                  {
                                    from: selectedFromDate,
                                    to: currentDate,
                                  },
                                ],
                              };
                            }
                          },
                        }}
                        onChange={handleToDateChange}
                      />
                    </div>

                    <div className="col-md-3 col-sm-12">
                      <FormGroup className="mt-2 mb-4">
                        <Label for="exampleSelect"></Label>
                        <div
                          id="exampleSelect"
                          className="sn-call-apply-btn-reset"
                        >
                          <Button
                            id="exampleSelect"
                            type="submit"
                            color="danger"
                            className=""
                            onClick={handleSubmit}
                            disabled={isLoading}
                          >
                            Apply
                          </Button>
                          <Button
                            className=""
                            style={{ marginLeft: "10px" }}
                            id="exampleSelect"
                            outline
                            color="danger"
                            onClick={resetInputHistory}
                            disabled={isLoading}
                          >
                            Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </div>
                  </div>

                  <Row className="g-3 mt-0 sn-employeessReport-tble-in-out sn-employessreport-alert-mainnn">
                    {isLoading === true && <Loader />}
                    {isLoading === false && (
                      <>
                        <Col
                          className="employe-report-not-pickup-colum-tbl sn-team-wise-tble-foter"
                          lg={12}
                        >
                          <div style={{ marginLeft: 0 }}>
                            <Table
                              columns={columns}
                              dataSource={employeeRportData}
                              pagination={false}
                              bordered
                              // size="middle"
                              scroll={{ x: "calc(700px + 50%)", y: 55 * 10 }}
                              rowKey="key"
                              expandable={{
                                expandedRowRender: (record) => (
                                  <ExpandedRow
                                    data={teamDataCache[record.key]}
                                    columns={expandedColumns}
                                  />
                                ),

                                expandedRowKeys: expandedRowKeys,
                                onExpand: (expanded, record) =>
                                  handleExpand(expanded, record),
                                expandIcon: () => null,
                                expandIconColumnIndex: -1,
                                expandRowByClick: true,
                                rowExpandable: () => true,
                              }}
                              rowClassName={(record) =>
                                expandedRowKeys.includes(record.key)
                                  ? "expanded-row"
                                  : ""
                              }
                            />
                          </div>
                        </Col>
                      </>
                    )}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default TeamWiseReport;
